'use client';

import { useAppsByAppKey } from '@/api/queries/useAppsByAppKey';
import { IntegratedApp } from '@/constants/apps';
import { useCurrentApp } from '@/stores/userDataStore';

const useHasTolstoyApp = () => {
  const { appUrl, appKey } = useCurrentApp();
  const { data: apps = [], isLoading } = useAppsByAppKey(appKey);
  const app = apps?.find((app) => app.active && app.app === IntegratedApp.SHOPIFY && app.appUrl === appUrl);

  return { hasApp: !!app, isLoading };
};

export default useHasTolstoyApp;
